var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessageReadIcon = function SvgMessageReadIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64436 4.25628C8.95448 3.91457 9.45729 3.91457 9.76741 4.25628C10.0775 4.59799 10.0775 5.15201 9.76741 5.49372L5.0027 10.7437C4.69258 11.0854 4.18977 11.0854 3.87965 10.7437L1.23259 7.82705C0.922469 7.48534 0.922469 6.93132 1.23259 6.58961C1.54271 6.24791 2.04552 6.24791 2.35564 6.58961L4.44118 8.88756L8.64436 4.25628Z",
    fill: "#3CE320"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5028 4.25628C13.8453 3.91457 14.4006 3.91457 14.7431 4.25628C15.0856 4.59799 15.0856 5.15201 14.7431 5.49372L9.48075 10.7437C9.13824 11.0854 8.58291 11.0854 8.2404 10.7437L7 9.45749L8.24035 8.22005L8.86057 8.88756L13.5028 4.25628Z",
    fill: "#3CE320"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessageReadIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messageReadIcon.87c77efe.svg";
export { ForwardRef as ReactComponent };